import React from "react";
import { audiences } from "../mock";

const Audiences = () => {
  return (
    <section id="audiences" className="bg-[#f6faf9] py-20 md:py-28 border-y border-black/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-black text-center max-w-3xl mx-auto leading-tight">
          Whether you serve{" "}
          <em className="text-teal-700 font-serif font-normal">
            thousands or ten.
          </em>
        </h2>
        <p className="mt-5 text-center text-black/60 max-w-2xl mx-auto">
          Good Fruit was built for anyone who believes the people around them
          deserve better than scattered tools and generic messages.
        </p>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-3 md:gap-4">
          {audiences.map((a, i) => (
            <span
              key={a}
              className={`px-5 py-2.5 rounded-full text-sm font-medium border transition-all duration-200 hover:-translate-y-0.5 ${
                i % 3 === 0
                  ? "bg-black text-white border-black hover:bg-teal-600 hover:border-teal-600"
                  : i % 3 === 1
                  ? "bg-white text-black border-black/15 hover:border-teal-600 hover:text-teal-700"
                  : "bg-teal-500/10 text-teal-800 border-teal-600/25 hover:bg-teal-500/20"
              }`}
            >
              {a}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Audiences;
